"use client";

import { IconDeleteAccountPage, IconForwardArrow } from "@repo/assets/images";
import { SendOtpForm, VerifyOtpForm } from "@repo/components";
import { useDeleteAccount } from "@repo/lib/hooks/account";
import { Button, OffCanvasDrawer } from "@repo/ui";
import { useTranslations } from "next-intl";
import { useCallback, useState } from "react";
const DeleteAccountWrapper = ({
  session
}) => {
  const t = useTranslations("Account");
  const tCommon = useTranslations("Common");
  const {
    showVerifyOTP,
    otpValue,
    setOtpValue,
    formValues,
    formErrors,
    setFormErrors,
    handleValidation,
    isPending,
    handleVerifyOtp,
    setShowVerifyOTP
  } = useDeleteAccount(session);
  const [openDeleteAccountDrawer, setDeleteAccountDrawer] = useState(false);
  const toggleDeleteAccountDrawer = useCallback(() => {
    setDeleteAccountDrawer(prev => !prev);
  }, []);
  return <>
      <Button size="md" variant="primary" type="button" onClick={toggleDeleteAccountDrawer} className="flex items-center font-semibold" data-sentry-element="Button" data-sentry-source-file="DeleteAccountWrapper.jsx">
        {tCommon("Delete_Account")}{" "}
        <span className="ms-auto ps-4">
          <IconForwardArrow className="text-inherit rtl:rotate-180" data-sentry-element="IconForwardArrow" data-sentry-source-file="DeleteAccountWrapper.jsx" />
        </span>
      </Button>
      {/* Drawer for desktop view */}
      <OffCanvasDrawer open={openDeleteAccountDrawer} handleClose={toggleDeleteAccountDrawer} title={tCommon("Delete_Account")} position="right" data-sentry-element="OffCanvasDrawer" data-sentry-source-file="DeleteAccountWrapper.jsx">
        <div className="px-6">
          <IconDeleteAccountPage className="mx-auto my-6" data-sentry-element="IconDeleteAccountPage" data-sentry-source-file="DeleteAccountWrapper.jsx" />
          {showVerifyOTP ? <>
              <p className="pb-6 text-sm text-[#49454F]">
                {tCommon("OTP_Heading")}
              </p>
              <VerifyOtpForm handleSubmit={handleVerifyOtp} otpValue={otpValue} setOtpValue={setOtpValue} isPending={isPending} formValues={formValues} />
            </> : <>
              <p className="pb-6 text-sm text-[#49454F]">
                {t("Delete_Account_Verify_Message")}
              </p>
              <SendOtpForm formValues={formValues} formErrors={formErrors} setFormErrors={setFormErrors} handleValidation={handleValidation} setShowVerifyOTP={setShowVerifyOTP} title="" description="" />
            </>}
        </div>
      </OffCanvasDrawer>
    </>;
};
export default DeleteAccountWrapper;